var t,i;function r(){if(i)return t;i=1;return t=class{constructor(t,i,r,s){this.city=t,this.state=i,this.zipCode=r,this.inputId=s,this.result=[]}}}export{r as __require};
